export default class KindergartenGroup {

    static fromData(data) {
        if (!data) {
            return;
        }

        let kindergartenGroup = new KindergartenGroup();
        kindergartenGroup.id = data.id;
        kindergartenGroup.name = data.name;

        return kindergartenGroup;
    }

}
